// Copyright (c) 2023, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 Inc. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import {
  List,
  ListItem,
  Box,
  Typography,
  Divider,
  Button,
} from "@mui/material";
import parse from "html-react-parser";
import { finishLine } from "../../config/constant";
import PracticalExamSubmissionDialog from "./PracticalExamSubmissionDialog";
import { RootState, useAppSelector } from "../../slices/store";
import { CountDownTimer } from "./CountDownTimer";
import { memo, useEffect, useState } from "react";

const MemoizedCountDownTimer = memo(CountDownTimer);

const PracticalExamPaper = () => {
  const examPaperState = useAppSelector((state: RootState) => state.examPaper);
  const examPaper = examPaperState.response;

  const [practicalPaper, setPracticalPaper] = useState({});

  useEffect(() => {
    if (examPaper) {
      const ids: any[] = [];
      examPaper.generatedQuestionSet.forEach((element: { id: any }) => {
        ids.push(element.id);
      });
      setPracticalPaper({
        paperId: examPaper.paperId,
        questions: ids,
      });
    }
  }, [examPaper]);

  return (
    <Box translate="no">
      <MemoizedCountDownTimer time={examPaper?.timeForPaper} />
      {examPaper?.generatedQuestionSet.map(
        (
          question: {
            content: { toString: () => string };
            otherContent: string | undefined;
          },
          index: number
        ) => (
          <List
            key={index}
            sx={{
              width: "100%",
              borderTop: "2px solid #212a32",
            }}
          >
            <ListItem alignItems="flex-start">
              <Box
                sx={{
                  backgroundColor: "primary.main",
                  padding: 1,
                  marginRight: 2,
                  color: "secondary.main",
                  fontWeight: "bold",
                  marginTop: 2,
                  textAlign: "center",
                  verticalAlign: "middle",
                }}
                translate="no"
              >
                Q{index + 1}:
              </Box>
              <Typography component={"span"}>
                {parse(question.content.toString())}
              </Typography>
            </ListItem>
            <Box
              sx={{
                textAlign: "center",
                verticalAlign: "middle",
              }}
            >
              <img width={"50%"} src={question.otherContent} />
            </Box>
          </List>
        )
      )}
      <Box py={10} translate="no">
        <Divider sx={{ marginBottom: 5 }} />
        <Typography sx={{ fontWeight: "bold" }} variant="body1" translate="no">
          Finish Line
        </Typography>
        <Typography variant="body2">{finishLine.practical}</Typography>
        <PracticalExamSubmissionDialog paperDetails={practicalPaper} />
        <Typography sx={{ textDecoration: "underline", mt: 4 }} variant="body1" translate="no">
          NOTICE
        </Typography>
        <Typography
          sx={{ fontStyle: "italic", color: "#3E5060" }}
          variant="body2"
        >
          {finishLine.notice}
        </Typography>
      </Box>
    </Box>
  );
};

export default PracticalExamPaper;
